export const CHECKOUT_URL = "https://blephadecision-en.impultienda.ar/checkout/";

export const images = {
  hero: "https://cdn.magicpatterns.com/uploads/vTtvKKoT2KFXMQE89ChAWo/BLEPHADECISION-EN.png",
  author: "https://cdn.magicpatterns.com/uploads/vnEPWSD58fKj5GS6vCE9G4/Daniel_Reynolds_-_Blefaroplastia.png",
};

export const methodSteps = [
  { name: "Predict", question: "What do you notice before seeing the educational review?" },
  { name: "Observe", question: "What can you actually identify from the information provided?" },
  { name: "Organize", question: "Which observations appear relevant?" },
  { name: "Question", question: "What information would you want to clarify?" },
  { name: "Prioritize", question: "Which observations deserve additional attention?" },
  { name: "Compare", question: "How does your reasoning compare with the educational discussion?" },
  { name: "Discover", question: "What did you notice? What did you miss? What would you review again?" },
];

export const painPoints = [
  { quote: "Where do I even start?", detail: "Multiple observations compete for your attention." },
  { quote: "I should probably review everything before I can form an opinion.", detail: "So you move between papers, lectures, notes and previous cases." },
  { quote: "Am I actually noticing the important things?", detail: "You see certain features, but you're not always sure what deserves closer attention." },
  { quote: "What am I missing?", detail: "You want a structured way to identify information gaps and unanswered questions." },
  { quote: "I keep studying, but I need more opportunities to practice.", detail: "More information doesn't automatically create better case-review habits." },
  { quote: "I want to learn something from every case.", detail: "But without structured reflection, valuable observations can disappear as soon as the review ends." },
];

export const volumes = [
  {
    number: "I",
    title: "The 15-Minute Decision Lab™ Method",
    intro: "I created this volume to answer one question: “How should I approach a new educational case?”",
    items: [
      "The complete sequence: Predict → Observe → Organize → Question → Prioritize → Compare → Discover",
      "The complete 15-Minute Case Analysis Sheet to practice the framework repeatedly",
    ],
    outro: "",
  },
  {
    number: "II",
    title: "The Upper Eyelid Decision Lab™",
    intro: "A dedicated case-practice framework for educational upper-eyelid cases.",
    items: ["Patient objectives", "Available case information", "Visual observations", "Relevant contextual factors", "Questions requiring further review", "Information gaps", "Priority observations", "Case reflection", "Educational review"],
    outro: "Instead of immediately looking for an answer, you'll practice explaining what you see and why it deserves attention.",
  },
  {
    number: "III",
    title: "The Lower Eyelid Decision Lab™",
    intro: "A structured collection of educational lower-eyelid case exercises.",
    items: ["Case context", "Patient objectives", "Visual assessment", "Relevant observations", "Variables requiring attention", "Questions to investigate", "Information gaps", "Priority areas", "Educational review", "Reflection"],
    outro: "The objective isn't memorizing conclusions. It's practicing how you reason through the information available to you.",
  },
  {
    number: "IV",
    title: "The 30-Case Decision Lab™",
    intro: "This is where the framework becomes practice: 30 educational blepharoplasty cases designed for repeated case-review training.",
    items: ["Review the case", "Write down what you notice", "Identify relevant variables", "Identify questions and information gaps", "Prioritize what deserves additional attention", "Compare your reasoning with the educational review", "Record what you learned"],
    outro: "One case at a time. Approximately 15 minutes. Repeated practice.",
  },
  {
    number: "V",
    title: "The Difficult Case Decision Lab™",
    intro: "Educational scenarios where multiple observations compete for attention. You'll practice identifying:",
    items: ["What information is available", "What appears uncertain", "What may deserve additional review", "What questions remain unanswered", "What observations could easily be overlooked", "What should be documented", "What you learned from the case"],
    outro: "I want you to practice recognizing when a case deserves deeper review.",
  },
  {
    number: "VI",
    title: "The Professional Case Learning Archive™",
    intro: "A case shouldn't stop being useful when you finish reviewing it. Templates for:",
    items: ["Case documentation", "Case reflection", "Case comparison", "Learning points", "Knowledge gaps", "Questions for future review", "Monthly case review", "Progress tracking", "Annual professional reflection"],
    outro: "You're building a record of how your case-review thinking develops.",
  },
];

export const tools = [
  { name: "The 15-Minute Case Analysis Sheet", desc: "The one-page version of the complete Decision Lab™ framework." },
  { name: "The Case Observation Grid", desc: "A visual structure for organizing what you notice before jumping to conclusions." },
  { name: "The Information Gap Tracker", desc: "A simple way to document what you still need to clarify." },
  { name: "The Case Comparison Matrix", desc: "Compare two educational cases side by side using the same framework." },
  { name: "The Case Reflection Sheet", desc: "Capture what you noticed, what you missed and what you want to review next." },
];

export const bonuses = [
  {
    number: 1,
    title: "30 Additional Educational Blepharoplasty Cases",
    value: 47,
    image: "https://cdn.magicpatterns.com/uploads/5RaAjGLAdLWFTLbBbsLLEn/BONUS_1_BLEPHADECISION-EN.png",
    desc: "Because one of the best ways to improve your case-review process is simply to practice it more often. 30 more cases built around the same Case → Think → Document → Compare → Learn framework.",
  },
  {
    number: 2,
    title: "The 10-Minute Rapid Decision Lab™",
    value: 37,
    image: "https://cdn.magicpatterns.com/uploads/kazqJKFuV99D12xXDPRTjG/BONUS_2_BLEPHADECISION-EN.png",
    desc: "Don't have 15 minutes? A compact case-review format designed for a quick educational session. 10 minutes. One case. One structured review.",
  },
  {
    number: 3,
    title: "The Blepharoplasty Oversight Atlas™",
    value: 47,
    image: "https://cdn.magicpatterns.com/uploads/4N3syYveGijsJGYCcGUWLt/BONUS_3_BLEPHADECISION-EN.png",
    desc: "Educational scenarios focused on details that are easy to overlook: what was noticed, what could be overlooked, what to ask and what may be missing. Train yourself to ask: “What else should I be looking at?”",
  },
  {
    number: 4,
    title: "The Case Review Cards™",
    value: 37,
    image: "https://cdn.magicpatterns.com/uploads/mHQj1orhTmRNQNcxmPqc9R/BONUS_4_BLEPHADECISIONE-N.png",
    desc: "Printable case-review prompts to use alone or in discussions with colleagues. One card. One question. One focused exercise to observe, question, compare, prioritize, reflect and review.",
  },
  {
    number: 5,
    title: "The 30-Day Decision Lab Challenge™",
    value: 29,
    image: "https://cdn.magicpatterns.com/uploads/dk1fdAahYvGkYni52KVyWz/BONUS_5_BLEPHADECISION-EN.png",
    desc: "Turn case review into a consistent practice. Every day: 1 case, 1 exercise, 1 reflection, 1 lesson. In 30 days you'll have completed 30 structured case-review sessions.",
  },
];

export const guaranteeItems = [
  "Open all six volumes",
  "Review the Decision Lab™ method",
  "Work through the educational cases",
  "Download the worksheets",
  "Use the case-review tools",
  "Explore all five bonuses",
  "Complete your first case reviews",
];

export const testimonials = [
  {
    name: "Dr. Elena Rodríguez",
    role: "Plastic Surgeon",
    headline: "What I value most is the structure.",
    quote: "Instead of opening a case and immediately looking for the answer, the Decision Lab forces me to explain what I actually see first.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/cfb85fc3-7652-45f6-80ea-a69d94687de5.jpg",
  },
  {
    name: "Dr. Richard Hale",
    role: "Aesthetic Physician",
    headline: "It made case review much more deliberate.",
    quote: "I now have a consistent way to work through an educational case instead of jumping between different notes and resources.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/2dcff161-1f02-49cc-90ae-25f7fe9791c8.jpg",
  },
  {
    name: "Dr. Mei Tanaka",
    role: "Oculoplastic Surgery Fellow",
    headline: "The case exercises are what I use most.",
    quote: "Writing down my reasoning before reading the review makes me notice things I previously overlooked.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/10402e4e-4155-4529-9b48-79da56cd10fc.jpg",
  },
  {
    name: "Dr. Marcus Bennett",
    role: "Facial Plastic Surgeon",
    headline: "It doesn't feel like another textbook.",
    quote: "It feels like something I can actually use with a case.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/58542d61-b07a-4240-b304-7af501b5a523.jpg",
  },
  {
    name: "Dr. Claire Whitman",
    role: "Aesthetic Medicine Educator",
    headline: "The comparison tools are particularly useful.",
    quote: "They give me a common framework for discussing cases and explaining what I noticed.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/4493b0c1-8bc7-471a-a01e-917f1f5702d4.jpg",
  },
];

export const beforeItems = [
  "You open a new case and aren't sure where to begin.",
  "You immediately look for someone else's answer.",
  "Different cases lead you to completely different review processes.",
  "Your case notes are inconsistent.",
  "You jump between articles, lectures and notes.",
  "You finish reviewing a case without clearly identifying what you learned.",
];

export const afterItems = [
  "You have a repeatable case-review process.",
  "You can work through an educational case in approximately 15 minutes.",
  "You document your reasoning before seeing the educational review.",
  "You identify information gaps and unanswered questions.",
  "You can compare your reasoning across different cases.",
  "You create a record of what you noticed, missed and learned.",
];

export const faqs = [
  { q: "How will I receive the Blepharoplasty Decision Lab™?", a: "Immediately after your purchase, you'll receive access to the digital materials and downloadable resources included in the product." },
  { q: "Who is the Blepharoplasty Decision Lab™ for?", a: "It is designed for qualified medical professionals who want a structured way to practice reviewing educational blepharoplasty cases." },
  { q: "Is this a surgical technique course?", a: "No. The Decision Lab™ is a case-based educational framework designed to help you practice organizing observations, questions, information gaps, priorities and reflections." },
  { q: "Does the Decision Lab™ tell me exactly what to do for every patient?", a: "No. It is not intended to provide individualized treatment recommendations or replace professional judgment, formal surgical training, supervision, current clinical guidelines or institutional protocols." },
  { q: "How long does each case take?", a: "The core framework is designed around an approximately 15-minute case-review session." },
  { q: "Can I print the materials?", a: "Yes. The worksheets and case-review tools are designed to be downloaded and printed." },
  { q: "Is this a one-time payment?", a: "Yes. You pay $27 once and receive lifetime digital access to the materials included in your purchase." },
  { q: "Do I need to be a specialist?", a: "The materials are designed for qualified medical professionals with an interest in educational blepharoplasty case analysis." },
  { q: "What happens if I don't find it useful?", a: "You have a 7-day guarantee. Explore the materials and decide whether the Decision Lab™ fits your professional learning workflow." },
];

export const recentBuyers = [
  { name: "María González", country: "Mexico" },
  { name: "Carlos Ramírez", country: "Colombia" },
  { name: "Lucía Fernández", country: "Spain" },
  { name: "Javier Morales", country: "Argentina" },
  { name: "Valentina Rojas", country: "Chile" },
  { name: "Andrés Castillo", country: "Peru" },
  { name: "Camila Herrera", country: "Ecuador" },
  { name: "Diego Vargas", country: "Uruguay" },
  { name: "Sofía Medina", country: "Costa Rica" },
  { name: "Mateo Jiménez", country: "Dominican Republic" },
  { name: "Isabella Torres", country: "Panama" },
  { name: "Alejandro Ruiz", country: "Guatemala" },
  { name: "Daniela Navarro", country: "Paraguay" },
  { name: "Fernando Ortega", country: "Venezuela" },
  { name: "Gabriela Peña", country: "Bolivia" },
];
